import React from 'react'
import PropTypes from 'prop-types'
import SetsAddCompForm from '../settings/SetsAddCompForm'
import Select from 'react-select'
import DatePicker from 'react-datepicker'
import moment from 'moment'
import classnames from 'classnames'
import { isEqual } from 'lodash'
import { sortOpts } from '../../utils/utils'
import Form from '../ui/Form'

class ExpenseAddPostForm extends Form {

  constructor(props){
    super(props);
    this.state = {
      data: props.data,
      showCreateComp: false,
      errors: {}
    };
  }

  updateSrvc = e => {
    if(this.props.srvcs[e.value].srvc_price !== 0){
      this.setState({
        data: {
          ...this.state.data,
          post_price: this.props.srvcs[e.value].srvc_price,
          post_srvc_id: e.value
        }
      });
    }
    else {
      this.setState({
        data: {
          ...this.state.data,
          post_srvc_id: e.value
        }
      });
    }
  }

  saveExpense = e => {
    e.preventDefault();
    const { data } = this.state;
    if(isEqual(data, this.props.data)){
      this.props.cancelAdding();
    }
    else{
      this.props.editExpense(data, (errors) => {
        if (errors) {
          this.setState({errors});
          return;
        }
        this.props.cancelAdding();
      });
    }
  }

  showCreateComp = () => {
    this.setState({
      showCreateComp: true
    });
  }

  hideCreateComp = () => {
    this.setState({
      showCreateComp: false
    });
  }

  selectAddedComp = id => {
    this.setState({
      data: {
        ...this.state.data,
        post_seller: id
      }
    });
  }

  render() {
    const { srvcs, srvgs, ctypes, comps, comprights, cancelAdding } = this.props;
    const { data, errors } = this.state;

    const showCreateComp = this.state.showCreateComp ?
      <SetsAddCompForm
        afterSave={this.selectAddedComp}
        addSets={this.props.addSets}
        onCancel={this.hideCreateComp}
        srvgs={srvgs}
        ctypes={ctypes}
        data={{
          comp_desc: '',
          comp_long: '',
          comp_city: '',
          comp_addr: '',
          comp_tel: '',
          comp_email: '',
          comp_note: '',
          comp_own: 0,
          comp_order: 0,
          comp_expense: 1,
          comp_cost: 0,
          comp_empl: 0,
          comp_ctype_id: 0,
          comp_srvg_ids: '',
          comp_active: 1
        }}
      />
      : '';

    var srvcsOpt = [];
    var pmntsOpt = [];
    for (let key in srvcs){
      if(srvcs.hasOwnProperty(key) && srvcs[key].srvc_active === 1){
        if(srvcs[key].srvc_expense === 1){
          srvcsOpt.push({value:srvcs[key].srvc_id,label:srvcs[key].srvc_desc});
        }
        if(srvcs[key].srvc_type === -1){
          pmntsOpt.push({value:srvcs[key].srvc_id,label:srvcs[key].srvc_desc});
        }
      }
    }
    srvcsOpt.sort(sortOpts);
    pmntsOpt.sort(sortOpts);

    var compsOpt = [];
    var comps1Opt = [];
    for (let key in comps){
      if(comps.hasOwnProperty(key) && comps[key].comp_active) {
        if(comps[key].comp_own && comprights.indexOf(parseInt(key,10))!==-1){
          comps1Opt.push({value:comps[key].comp_id,label:comps[key].comp_desc});
        }
        if(comps[key].comp_expense){
          compsOpt.push({value:comps[key].comp_id,label:comps[key].comp_desc});
        }
      }
    }
    compsOpt.sort(sortOpts);
    comps1Opt.sort(sortOpts);

    const addPmntStyle = this.state.data.pmnt_add ? {} : {display:'none'};

    return (
      <div
        className="modal "
        style={{
          paddingTop:'15%',
          overflowY:'visible',
          backgroundColor: 'rgba(30,30,30,.7)',
          display:'block'
        }}
      >
        <div
          className="container"
        >
          <div className="modal-content">
            <div className="modal-header">
              <h4 style={{margin:0}}>Добавление записи</h4>
        { errors.form && <div className="alert alert-danger">{errors.form}</div> }
            </div>
            <div className="modal-body">
              <div className="row">
                <div className="col-sm-3">
                {showCreateComp}
                  <div className={classnames('form-group', { 'has-error': errors.post_srvc_id })}>
                    Услуга
                    <Select
                      clearable={false}
                      options={srvcsOpt}
                      value={data.post_srvc_id}
                      onChange={e => this.updateSrvc(e)}
                      placeholder="Услуга"
                    />
                    {errors.post_srvc_id && <span className="help-block">{errors.post_srvc_id}</span>}
                  </div>
                  <div className="form-group">
                    Описание
                    <input type="text"
                      className="form-control"
                      value={data.post_desc}
                      name="post_desc"
                      onChange={this.updateInput}
                      placeholder="Описание"
                    />
                  </div>
                  <button
                    type="button"
                    className="btn btn-default"
                    onClick={cancelAdding}
                  >
                    Отменить
                  </button>{" "}
                  <button
                    type="button"
                    className="btn btn-success"
                    onClick={this.saveExpense}
                  >
                    Сохранить
                  </button>
                </div>
                <div className="col-sm-3">
                  <div className="form-group">
                    Дата
                    <DatePicker
                      className="form-control"
                      showMonthDropdown
                      showYearDropdown
                      dropdownMode="select"
                      selected={moment(data.post_bdate)}
                      onChange={(e) => this.updateDate(e, 'post_bdate')}
                    />
                  </div>
                  <div className="form-group">
                    Цена
                    <input type="text"
                      className="form-control"
                      value={data.post_price}
                      name="post_price"
                      onChange={this.updateInput}
                      placeholder="Цена" title="Цена"
                    />
                  </div>
                  <div className="form-group">
                    Кол-во
                    <input type="text"
                      className="form-control"
                      value={data.post_qntt}
                      name="post_qntt"
                      onChange={this.updateInput}
                      placeholder="Кол-во" title="Кол-во"
                    />
                  </div>
                </div>
                <div className="col-sm-3">
                  <div className={classnames('form-group', { 'has-error': errors.post_seller })}>
                    Поставщик
                    <div>
                      <div style={{
                        display: 'inline-block',
                        width: 'calc(100% - 45px)',
                        verticalAlign: 'middle'
                      }}>
                        <Select
                          clearable={false}
                          options={compsOpt}
                          value={data.post_seller}
                          onChange={e => this.updateSelect(e,'post_seller')}
                          placeholder="Поставщик"
                        />
                      </div>
                      <button type="button" className="btn btn-default"
                        onClick={this.showCreateComp}
                        title="Создать поставщика"
                      >
                        <span className="glyphicon glyphicon-plus"></span>
                      </button>
                      {errors.post_seller && <span className="help-block">{errors.post_seller}</span>}
                    </div>
                  </div>
                  <div className="form-group">
                    Плательщик:
                    <Select
                      clearable={false}
                      options={comps1Opt}
                      value={data.post_payer}
                      onChange={e => this.updateSelect(e,'post_payer')}
                      placeholder="Плательщик"
                    />
                  </div>
                  <div className="form-group">
                    Заметка
                    <textarea type="text"
                      className="form-control"
                      value={data.post_note}
                      name="post_note"
                      onChange={this.updateInput}
                      placeholder="Заметка"
                      title="Заметка"
                    />
                  </div>
                </div>
                <div className="col-sm-3">
                  <div>
                    <div className="form-group">
                      <div className="checkbox">
                        <label><input
                          type="checkbox"
                          checked={data.pmnt_add}
                          name="pmnt_add"
                          onChange={this.handleChBox}
                        /> добавить оплату</label>
                      </div>
                    </div>
                    <div style={addPmntStyle}>
                      <div className="form-group">
                        <Select
                          clearable={false}
                          options={pmntsOpt}
                          value={data.pmnt_srvc_id}
                          onChange={e => this.updateSelect(e,'pmnt_srvc_id')}
                          placeholder="Метод оплаты"
                        />
                      </div>
                      <div className="form-group">
                        <DatePicker
                          className="form-control"
                          showMonthDropdown
                          showYearDropdown
                          dropdownMode="select"
                          selected={moment(data.pmnt_bdate)}
                          onChange={(e) => this.updateDate(e, 'pmnt_bdate')}
                        />
                      </div>
                      <div className="checkbox">
                        <label>
                          <input type="checkbox" checked={data.pmnt_payed}
                            name="pmnt_payed" onChange={this.handleChBox} /> Оплачено
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )

  }
}

ExpenseAddPostForm.propTypes = {
  editExpense: PropTypes.func.isRequired,
  cancelAdding: PropTypes.func.isRequired,
  addSets: PropTypes.func.isRequired,
  srvcs: PropTypes.object.isRequired,
  srvgs: PropTypes.object.isRequired,
  comps: PropTypes.object.isRequired,
  comprights: PropTypes.array.isRequired
}

export default ExpenseAddPostForm;



// WEBPACK FOOTER //
// ./src/components/expense/ExpenseAddPostForm.js